import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_VDOSET,
  GET_VDOSETS,
  GET_VDOSETS_BY_FILTER,
  ADD_VDOSET,
  UPDATE_VDOSET,
  DELETE_VDOSET
} from '@/queries/modules/vdoSet/vdoSet.js';

export async function getVdoSets(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOSETS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setVdoSets', data.getVdoSets);
      context.commit('setSuccess', null);
      return data.getVdoSets
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getVdoSetsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOSETS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setVdoSets', data.getVdoSetsByFilter);
      context.commit('setSuccess', null);

      return data.getVdoSetsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getVdoSet(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOSET,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setVdoSet', data.getVdoSet);
      context.commit('setSuccess', null);
      return data.getVdoSet
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addVdoSet(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_VDOSET,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const vdoSets = [...context.state.vdoSets];
      vdoSets.push(data.addVdoSet);
      context.commit('setVdoSets', vdoSets);
      context.commit('setSuccess', newItemSuccess(data.addVdoSet.sectionNo));

      return data.addVdoSet
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateVdoSet(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_VDOSET,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.vdoSets.findIndex(item => item.id === data.updateVdoSet.id);
      const vdoSets = [
        ...context.state.vdoSets.slice(0, index),
        data.updateVdoSet,
        ...context.state.vdoSets.slice(index + 1)
      ];
      context.commit('setVdoSets', vdoSets);
      context.commit('setSuccess', updateItemSuccess(data.updateVdoSet.sectionNo));

      return data.updateVdoSet
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteVdoSet(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_VDOSET,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.vdoSets.findIndex(item => item.id === data.deleteVdoSet.id);
      const vdoSets = [
        ...context.state.vdoSets.slice(0, index),
        ...context.state.vdoSets.slice(index + 1)
      ];
      context.commit('setVdoSets', vdoSets);
      context.commit('setSuccess', deleteItemSuccess(data.deleteVdoSet.sectionNo));

      return data.deleteVdoSet
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

